import * as Vue from 'vue'

import App from '@/App.vue'
import router from '@/routes'
import store from '@/store'

import Layout from '@/components/Layout.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import LegalNoticePopup from '@/components/LegalNoticePopup.vue'
import ValidationError from '@/components/ValidationError.vue'
import Countdown from '@/components/Countdown.vue'
import Tooltip from '@/components/Tooltip.vue'
import XInput from '@/components/XInput.vue'
import Captcha from '@/components/Captcha.vue'
import Pisano from '@/components/Pisano.vue'


const { createApp } = Vue

const app = createApp(App)

app.config.globalProperties.$app = app

app.use(store)
app.use(router)
app.mount('#app')

app
.component('Layout', Layout)
.component('ErrorMessage', ErrorMessage)
.component('LegalNoticePopup', LegalNoticePopup)
.component('ValidationError', ValidationError)
.component('Countdown', Countdown)
.component('Tooltip', Tooltip)
.component('XInput', XInput)
.component('Captcha', Captcha)
.component('Pisano', Pisano)